import { IconComponentConfig, TextComponentConfig } from '..';

export interface CardNineItem {
    text: TextComponentConfig;
    description: TextComponentConfig;
    icon: IconComponentConfig;
    backgroundColor: string;
}
